import React from 'react'
import parse from 'html-react-parser'
import Link from '../utils/link'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from 'react-google-maps'

import markerIcon from '../assets/images/marker.svg'

import { styles } from '../utils/map-props'

import useOfficesQuery from '../hooks/use-offices-query'
import { GatsbyImage } from 'gatsby-plugin-image'

const MapWithAMarker = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    defaultCenter={{ lat: -33.8672582, lng: 151.1031117 }}
    defaultZoom={12}
    options={{
      mapTypeControl: false,
      fullscreenControl: false,
      rotateControl: false,
      clickableIcons: true,
      scrollwheel: false,
      styles: styles
    }}
  >
    { props?.offices?.map((office, i) => {
      const location = { lat: parseFloat(office?.acf?.googleMap?.latitude), lng: parseFloat(office?.acf?.googleMap?.longitude) }
      return (
        <Marker
          position={location}
          icon={{ url: markerIcon, size: {width: 38, height: 60}, anchor: {x:19 , y: 30}, scaledSize: {width: 38, height: 60} }}
          onClick={() => props.handleActiveMarker(office.uri)}
        >
          {props.activeMarker === office.uri ? (
            <InfoWindow onCloseClick={() => props.setActiveMarker(null)}>
              <div className='card card--map'>
                { office?.acf?.officeImage?.localFile?.childImageSharp?.gatsbyImageData &&
                  <div className='card__image'>
                    <Link to={office.uri}><GatsbyImage image={office?.acf?.officeImage?.localFile?.childImageSharp?.gatsbyImageData} alt={office?.title} /></Link>
                  </div>
                }
                <h5><Link to={office.uri}>{parse(office.title)}</Link></h5>
                <ul>
                  <li><Link to={`tel:${office.officeDetails?.phone}`}>{office.officeDetails?.phone}</Link></li>
                  <li>{office.officeDetails?.address?.streetAddress}<br />{office.officeDetails?.address?.suburb} {office.officeDetails?.address?.state} {office.officeDetails?.address?.postcode}</li>
                  <li><Link to={`mailto:${office.officeDetails?.email}`}>Email Office</Link></li>
                </ul>
              </div>
            </InfoWindow>
          ) : null}
        </Marker>
      )
    })}
  </GoogleMap>
))

const OfficeMap = ({ title }) => {
  const offices = useOfficesQuery()

  const [activeMarker, setActiveMarker] = React.useState(null);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  // Don't render SSR
  if (typeof window === 'undefined') return (<section className='map' />);

  return (
    <section className='office-map'>
      <div className='office-map__inner'>
        { title && <h2 className='office-map__title'>{parse(title)}</h2> }
        <div className='map__wrapper'>
          <MapWithAMarker
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GOOGLE_MAP_API}&v=3.exp&libraries=geometry,drawing,places`}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div className={'map__element'} />}
            offices={offices}
            handleActiveMarker={handleActiveMarker}
            setActiveMarker={setActiveMarker}
            activeMarker={activeMarker}
          />
        </div>
      </div>
    </section>
  )
}

export default OfficeMap
